import { BackendDataDto } from '@app/backend/metadoor-api-client';
import { MonitoringFinanceComparisonPeriod } from '@app/monitoring/monitoring.constants';
import { createActionGroup } from '@ngrx/store';

export interface IFinanceComparisonsTableParams {
  scenarioId: number;
  page?: number; // TODO: perf - удалить - нет пользы
  period: MonitoringFinanceComparisonPeriod;
}

const MonitoringFinanceComparisonsActionGroup = createActionGroup({
  source: 'Monitoring Finance Comparison',
  events: {
    // setCurrentMonitoringFinanceComparisonType
    'Set Current Monitoring Finance Comparison Type': (payload: string) => ({ payload }),
    // getFinanceComparisonProfitAndLost
    'Get Finance Comparison Profit And Lost': (payload: IFinanceComparisonsTableParams) => ({ payload }),
    'Get Finance Comparison Profit And Lost Success': (payload: BackendDataDto) => ({ payload }),
    'Get Finance Comparison Profit And Lost Failure': (payload: unknown) => ({ payload }),
    // getFinanceComparisonCashFlow
    'Get Finance Comparison Cash Flow': (payload: IFinanceComparisonsTableParams) => ({ payload }),
    'Get Finance Comparison Cash Flow Success': (payload: BackendDataDto) => ({ payload }),
    'Get Finance Comparison Cash Flow Failure': (payload: unknown) => ({ payload }),
    // getFinanceComparisonBalance
    'Get Finance Comparison Balance': (payload: IFinanceComparisonsTableParams) => ({ payload }),
    'Get Finance Comparison Balance Success': (payload: BackendDataDto) => ({ payload }),
    'Get Finance Comparison Balance Failure': (payload: unknown) => ({ payload }),
    // getFinanceComparisonCoefficients
    'Get Finance Comparison Coefficients': (payload: IFinanceComparisonsTableParams) => ({ payload }),
    'Get Finance Comparison Coefficients Success': (payload: BackendDataDto) => ({ payload }),
    'Get Finance Comparison Coefficients Failure': (payload: unknown) => ({ payload }),
    // getFinanceComparisonSales
    'Get Finance Comparison Sales': (payload: IFinanceComparisonsTableParams) => ({ payload }),
    'Get Finance Comparison Sales Success': (payload: BackendDataDto) => ({ payload }),
    'Get Finance Comparison Sales Failure': (payload: unknown) => ({ payload }),
  },
});

export const {
  setCurrentMonitoringFinanceComparisonType,
  getFinanceComparisonProfitAndLost,
  getFinanceComparisonProfitAndLostSuccess,
  getFinanceComparisonProfitAndLostFailure,
  getFinanceComparisonCashFlow,
  getFinanceComparisonCashFlowSuccess,
  getFinanceComparisonCashFlowFailure,
  getFinanceComparisonBalance,
  getFinanceComparisonBalanceSuccess,
  getFinanceComparisonBalanceFailure,
  getFinanceComparisonCoefficients,
  getFinanceComparisonCoefficientsSuccess,
  getFinanceComparisonCoefficientsFailure,
  getFinanceComparisonSales,
  getFinanceComparisonSalesSuccess,
  getFinanceComparisonSalesFailure,
} = MonitoringFinanceComparisonsActionGroup;
